import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  IconButton,
  Toolbar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { InnerToolBarContianer } from "./style";
import { AppBar as MUIAppBar } from "./style";
import CustomProfileMenu from "./customComponents/CustomProfileMenu";
import CustomMessageNotificationMenu from "./customComponents/CustomMessageNotificationMenu";
import CustomMessageMenuButton from "./customComponents/CustomMessageMenuButton";
import CustomProfileMenuButton from "./customComponents/CustomProfileMenuButton";
import CustomPageHeader from "./customComponents/CustomPageHeader";
import userTypes from "../../constants/userTypes";
import { appColors } from "../../constants/theme";
import { useNavbarNotifications } from "../../hooks/useNavbarNotifications";

const AppBar = ({ open, isMobile, handleDrawerOpen }) => {
  const receivedNotifications = useSelector((state) => state.app.receivedNotifications);
  const userTypeUpper = String(
    useSelector((state) => state.auth?.user?.userType || state.auth?.role?.name || "")
  ).toUpperCase();
  const isDoctor = userTypeUpper === userTypes.DOCTOR;
  const showNotificationBell =
    isDoctor ||
    userTypeUpper === userTypes.PATIENT ||
    userTypeUpper === userTypes.ASSISTANT;

  const { menuList, unreadCount } = useNavbarNotifications({
    enabled: isDoctor,
    liveNotifications: receivedNotifications,
  });

  const notificationMenuList = isDoctor ? menuList : receivedNotifications;
  const notificationBadgeCount = isDoctor
    ? unreadCount
    : receivedNotifications?.length || 0;

  const [anchorProfileMenuEl, setAnchorProfileMenuEl] = React.useState(null);
  const openProfileMenu = Boolean(anchorProfileMenuEl);
  const handleClickProfileMenu = (event) => {
    setAnchorProfileMenuEl(event.currentTarget);
  };
  const handleProfileMenuCLose = () => {
    setAnchorProfileMenuEl(null);
  };

  const [anchorMessageMenuEl, setAnchorMessageMenuEl] = React.useState(null);
  const openMessageMenu = Boolean(anchorMessageMenuEl);
  const handleClickMessageMenu = (event) => {
    setAnchorMessageMenuEl(event.currentTarget);
  };
  const handleMessageMenuCLose = () => {
    setAnchorMessageMenuEl(null);
  };

  useEffect(() => {
    if (notificationMenuList.length === 0) setAnchorMessageMenuEl(null);
  }, [notificationMenuList]);

  return (
    <MUIAppBar position="fixed" open={open}>
      <Toolbar disableGutters>
        {isMobile && (
          <IconButton
            color="inherit"
            aria-label="Menüyü aç"
            onClick={handleDrawerOpen}
            edge="start"
            size="medium"
            sx={{
              color: appColors.gray900,
              mr: 0.5,
              flexShrink: 0,
            }}
          >
            <MenuIcon />
          </IconButton>
        )}
        <InnerToolBarContianer>
          <CustomPageHeader />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 0.25, md: 0.5 },
              flexShrink: 0,
            }}
          >
            {showNotificationBell && (
              <CustomMessageMenuButton
                handleClickMessageMenu={handleClickMessageMenu}
                openMessageMenu={openMessageMenu}
                unreadCount={notificationBadgeCount}
              />
            )}
            <CustomProfileMenuButton
              openProfileMenu={openProfileMenu}
              handleClickProfileMenu={handleClickProfileMenu}
            />
          </Box>
          <CustomProfileMenu
            anchorEl={anchorProfileMenuEl}
            open={openProfileMenu}
            handleClose={handleProfileMenuCLose}
          />
          <CustomMessageNotificationMenu
            anchorEl={anchorMessageMenuEl}
            open={openMessageMenu}
            handleClose={handleMessageMenuCLose}
            list={notificationMenuList}
          />
        </InnerToolBarContianer>
      </Toolbar>
    </MUIAppBar>
  );
};

export default AppBar;
